import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

import WebRtcCall from "~/core-ui/vue/chat/webrtc/WebRtcCall.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {computed, onBeforeUnmount, onMounted} from "vue";
import OperatorApplicationWebRtcCall from "~/operatorApplication/ts/service/webRtc/OperatorApplicationWebRtcCall";
import CoreUiAvatar from "~/core-ui/vue/chat/CoreUiAvatar.vue";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import getOperatorGroupsForForward
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/getOperatorGroupsForForward";
import OperatorApplicationForwardButton
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationForwardButton.vue";
import ForwardToOperatorEventInterface
    from "~/operatorApplication/vue/dialogs/dialog/topmenu/ForwardToOperatorEventInterface";
import {OPERATOR_STATUS_OFFLINE} from "~/chat/ts/data/OperatorStatus";
import {__} from "~/ts/library/Translate";

import OperatorGetParamsOperatorOpenApiModel = OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel;

const __default__ = {
    name: "OperatorApplicationWebRtcCallDisplay"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    call: {}
  },
  setup(__props: any) {

let props = __props;

onMounted(() => {
    props.call.setMountedNow(true);
});

onBeforeUnmount(() => {
    props.call.setMountedNow(false);
});

let userdata = computed(() => {
    let username = props.call.getCallData()?.username;
    if (username) {
        return ClientUserdataStore.getByUsername(username, false);
    }
    return null;
})

let site = computed(() => {
    if (userdata.value) {
        return OperatorAccountStore.sitesDictionary.value[userdata.value.siteId];
    }
    return null;
});

function operatorFilterFunction(operator: OperatorGetParamsOperatorOpenApiModel) {
    let users = props.call.getCallData()?.users;
    if (users) {
        if (users.find(user => user.operatorLogin === operator.login)) {
            return false;
        }
    }
    return true;
}

let operatorGroupsForInvite = computed(() => {
    if (userdata.value?.type.isCrossOperatorsChat) {
        return [{
            id: "all",
            descr: __("Все операторы"),
            operators: OperatorAccountStore.data.value.operators
                .filter(operator => operator.statusId != OPERATOR_STATUS_OFFLINE && !!operator.chatId)
                .filter(operatorFilterFunction)
        }];
    } else if (site.value) {
        return getOperatorGroupsForForward(site.value, operatorFilterFunction);
    }
    return [];
});

function invite(event: ForwardToOperatorEventInterface) {
    if (event.operatorLogin) {
        props.call.inviteUser(event.operatorLogin);
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createBlock(WebRtcCall, {
    call: __props.call,
    class: "p-2"
  }, _createSlots({
    "close-config-button": _withCtx(() => [
      _createVNode(_component_el_button, {
        class: "d-block w-100",
        type: "primary"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Закрыть настройки ", -1)
        ]))]),
        _: 1
      })
    ]),
    avatar: _withCtx(({avatar}) => [
      _createVNode(CoreUiAvatar, {
        size: "64px",
        src: avatar.url,
        background: avatar.background
      }, null, 8, ["src", "background"])
    ]),
    hangup: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "danger",
        circle: ""
      }, {
        default: _withCtx(() => [
          _createVNode(FontAwesomeIcon, { icon: "phone" })
        ]),
        _: 1
      })
    ]),
    camera: _withCtx(({enabled}) => [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, { circle: "" }, {
        default: _withCtx(() => [
          _createVNode(FontAwesomeIcon, {
            icon: enabled ? 'camera' : 'camera-slash'
          }, null, 8, ["icon"])
        ]),
        _: 2
      }, 1024)), [
        [_directive_my_tooltip, enabled ? 'Отключить камеру' : 'Включить камеру']
      ])
    ]),
    "selfie-segmentation": _withCtx(({enabled}) => [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, { circle: "" }, {
        default: _withCtx(() => [
          _createVNode(FontAwesomeIcon, {
            icon: enabled ? 'users-viewfinder' : 'face-viewfinder'
          }, null, 8, ["icon"])
        ]),
        _: 2
      }, 1024)), [
        [_directive_my_tooltip, enabled ? 'Отключить размытие фона' : 'Включить размытие фона']
      ])
    ]),
    config: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, { circle: "" }, {
        default: _withCtx(() => [
          _createVNode(FontAwesomeIcon, { icon: "cog" })
        ]),
        _: 1
      })), [
        [_directive_my_tooltip, `Настройки`]
      ])
    ]),
    microphone: _withCtx(({enabled}) => [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, { circle: "" }, {
        default: _withCtx(() => [
          _createVNode(FontAwesomeIcon, {
            icon: enabled ? 'microphone' : 'microphone-slash'
          }, null, 8, ["icon"])
        ]),
        _: 2
      }, 1024)), [
        [_directive_my_tooltip, enabled ? 'Отключить микрофон' : 'Включить микрофон']
      ])
    ]),
    desktop: _withCtx(({enabled}) => [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, { circle: "" }, {
        default: _withCtx(() => [
          _createVNode(FontAwesomeIcon, {
            icon: enabled ? 'video' : 'desktop'
          }, null, 8, ["icon"])
        ]),
        _: 2
      }, 1024)), [
        [_directive_my_tooltip, enabled ? 'Остановить показ экрана' : 'Начать показ экрана']
      ])
    ]),
    fullscreen: _withCtx(({enabled}) => [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, { circle: "" }, {
        default: _withCtx(() => [
          _createVNode(FontAwesomeIcon, {
            icon: enabled ? 'compress-alt' : 'expand-alt'
          }, null, 8, ["icon"])
        ]),
        _: 2
      }, 1024)), [
        [_directive_my_tooltip, enabled ? 'Свернуть' : 'Развернуть']
      ])
    ]),
    noaudio: _withCtx(() => [
      _createVNode(FontAwesomeIcon, {
        icon: "microphone-slash",
        class: "text-white"
      })
    ]),
    novideo: _withCtx(() => [
      _createVNode(FontAwesomeIcon, {
        icon: "camera-slash",
        class: "text-white"
      })
    ]),
    _: 2
  }, [
    (_unref(operatorGroupsForInvite).length)
      ? {
          name: "after-buttons",
          fn: _withCtx(() => [
            _createElementVNode("span", null, [
              _createVNode(_component_el_popover, {
                "popper-class": "p-0 text-left",
                "popover-placement": "top",
                teleported: false
              }, {
                reference: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _withDirectives((_openBlock(), _createBlock(_component_el_button, { circle: "" }, {
                      default: _withCtx(() => [
                        _createVNode(FontAwesomeIcon, { icon: "plus" })
                      ]),
                      _: 1
                    })), [
                      [_directive_my_tooltip, `Добавить оператора`]
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(OperatorApplicationForwardButton, {
                    site: _unref(site),
                    groups: _unref(operatorGroupsForInvite),
                    onForward: _cache[0] || (_cache[0] = ($event: any) => (invite($event)))
                  }, null, 8, ["site", "groups"])
                ]),
                _: 1
              })
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["call"]))
}
}

})